<template>
  <div :class="componentClassName">
    <a-icon :icon="currentIcon" color="white" class="a-sf-calling-status__icon" />
    <span class="a-sf-calling-status__text">{{ statusText }}</span>
    <span class="a-sf-calling-status__time">
      <slot>{{ time }}</slot>
    </span>
  </div>
  <div v-if="pbSettingName && minimized" :class="componentClassName">
    <span class="a-sf-calling-status__text">{{ pushNumberSettingName }}</span>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AIcon from '@/components/atoms/icon';
import { utils } from '@/common/utils.js';

export default {
  name: 'a-sf-calling-status',
  components: {
    AIcon,
  },
  mixins: [utils],
  props: {
    class: {
      type: String,
      default: '',
    },
    time: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: 'active',
      validator(value) {
        return value.match(/(active|onhold|transfer|ended)/);
      },
    },
    minimized: {
      type: Boolean,
      default: false,
    },
    pbSettingName: {
      type: String,
      default: '',
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-sf-calling-status', this.status, this.minimized ? 'minimized' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
    statusText() {
      if (this.status === 'active') {
        return '通話中';
      } else if (this.status === 'onhold') {
        return '保留中';
      } else if (this.status === 'ended') {
        return '通話終了';
      }
      return '';
    },
    currentIcon() {
      if (this.status === 'onhold') {
        return 'phone-call-onhold';
      } else if (this.status === 'transfer') {
        return 'phone-call-transfer';
      }
      return 'phone-call-active';
    },
    pushNumberSettingName() {
      return this.collapseText(this.pbSettingName, 10);
    },
  },
};
</script>
